import colors from './colors';

export default {
    content: {
        width: 483,
        maxWidth: '90%',
        height: 'auto',
        margin: '10px auto 0px',
        borderRadius: 0,
        border: 'none',
        position: 'relative',
        top: 'unset',
        bottom: 'unset',
        left: 'unset',
        right: 'unset',
        overflow: 'visible',
        padding: 0,
    },
    overlay: {
        zIndex: 100,
        backgroundColor: colors.black38,
        overflowY: 'scroll',
        paddingBottom: 30,
    },
};
